export default class Configuration {
  /**
   * Create new commission plan and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @param {string} id
   */
  set id (value) {
    this._id = `${value}`
  }

  /**
   * @return {string}
   */
  get id () {
    return this._id
  }
}
